"use strict";

exports.__esModule = true;
exports.AlertDetailsViewMode = AlertDetailsViewMode;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Translator = require("../../Core/Translator");
var _System = require("../../../System");
var _DetailsComponent = require("../../Core/DetailsComponent");
var _AlertComments = require("./AlertComments");
var _AlertTicketTag = require("../../Core/AlertTicketTag");
var _reactIntl = require("react-intl");
var _Device = require("../../Device");
var _common = require("../../Device/common");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function AlertDetailsViewMode(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var devices = _react["default"].useContext(_Device.DeviceListContext);
  var alertDetails = props.alertDetails,
    width = props.width,
    height = props.height,
    createAlertComment = props.createAlertComment,
    onClose = props.onClose,
    isFullScreen = props.isFullScreen,
    handleAcknowledged = props.handleAcknowledged;
  var _useState = (0, _react.useState)(false),
    isAcknowledged = _useState[0],
    setIsAcknowledged = _useState[1];
  var device = alertDetails.device,
    name = alertDetails.name,
    description = alertDetails.description,
    tags = alertDetails.tags,
    comments = alertDetails.comments,
    id = alertDetails.id,
    acknowledged = alertDetails.acknowledged,
    _alertDetails$watcher = alertDetails.watchers,
    watchers = _alertDetails$watcher === void 0 ? [] : _alertDetails$watcher;
  (0, _react.useEffect)(function () {
    setIsAcknowledged(acknowledged);
  }, [acknowledged]);

  // TODO: Do this in the controller
  var style = {
    maxHeight: isFullScreen ? "unset" : "50px",
    overflow: "auto"
  };
  var getDeviceName = function getDeviceName(value, type) {
    if (type && type === "UUID") {
      var _device = (0, _common.getDevice)(devices, value);
      return _device ? _device.name : value;
    }
    return value;
  };
  return /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsContainer, {
    "data-testid": "NewAlertDetailsView",
    width: width,
    height: height,
    isFullScreen: isFullScreen
  }, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsHeader, {
    isFullScreen: isFullScreen,
    showRightAligned: true
  }, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.HeaderButtonGroup, {
    isFullScreen: true
  }, isFullScreen ? null : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: (0, _System.getScreenURL)("AlertDetails", {
      id: id
    }),
    target: "_blank",
    rel: "noreferrer noopener"
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    minimal: true,
    icon: _icons.IconNames.DOCUMENT_OPEN
  })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    minimal: true,
    icon: _icons.IconNames.CROSS,
    onClick: onClose
  }))), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSectionWrapper, {
    isFullScreen: isFullScreen
  }, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSection, null, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    heading: translate("AlertDetails.name", "Name"),
    content: name
  }), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    heading: translate("AlertDetails.description", "Summary"),
    content: description
  }), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    heading: translate("AlertDetails.device", "Device"),
    content: /*#__PURE__*/_react["default"].createElement("p", {
      style: style
    }, getDeviceName(device.value, device.type))
  }), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    heading: translate("AlertDetails.acknowledged", "Acknowledged"),
    content: isAcknowledged ? translate("yes", "Yes") : translate("no", "No")
  }), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    heading: translate("AlertDetails.tags", "Tags"),
    content: /*#__PURE__*/_react["default"].createElement(_AlertTicketTag.AlertTicketTag, {
      style: style,
      getKey: function getKey(tag) {
        return tag;
      },
      getValue: function getValue(tag) {
        return tag;
      },
      content: tags
    })
  }), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    heading: translate("AlertDetails.watchers", "Watchers"),
    content: /*#__PURE__*/_react["default"].createElement("p", {
      style: style
    }, watchers.join(", "))
  })), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsCommentsSection, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    style: {
      marginBottom: "0.5rem",
      maxWidth: "100px"
    },
    type: "submit",
    intent: _core.Intent.PRIMARY,
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "AlertDetailsPage.acknowledge.button",
      defaultMessage: "Acknowledge"
    }),
    onClick: function onClick() {
      setIsAcknowledged(!acknowledged);
      handleAcknowledged(!acknowledged);
    },
    disabled: isAcknowledged
  }), /*#__PURE__*/_react["default"].createElement(_AlertComments.AlertComments, {
    comments: comments,
    onSubmit: createAlertComment,
    isFullScreen: isFullScreen
  }))));
}